
import { 
  Item,
} from "@dndModels/item/ItemModel";
import { 
  ArmorType
} from "@dndModels";

export class Armor extends Item {
  armor_type_id = "";
  base_armor_class = 10;
  stealth_disadvantage: boolean | null = null;
  require_special_proficiency = false;
  strength_requirement = 0; // The Strength score needed to wear it without losing speed. 0 if there isn't one.
  armor_type: ArmorType | null = null;
  // dex_bonus_max: number = -1; 
  // speed_loss: number = 0;
  // comfortable: boolean = false;

  constructor(obj?: any) {
    super(obj);
    this.item_type = "Armor";
    if (obj) {
      this.armor_type_id = obj.armor_type_id ? obj.armor_type_id : "";
      this.base_armor_class = obj.base_armor_class ? obj.base_armor_class : 10;
      this.stealth_disadvantage = obj.stealth_disadvantage ? obj.stealth_disadvantage : null;
      this.require_special_proficiency = obj.require_special_proficiency ? obj.require_special_proficiency : false;
      this.strength_requirement = obj.strength_requirement ? +obj.strength_requirement : 0;
      // this.dex_bonus_max = obj.dex_bonus_max ? obj.dex_bonus_max : -1;
      // this.speed_loss = obj.speed_loss ? obj.speed_loss : 0;
      // this.comfortable = obj.comfortable ? obj.comfortable : false;
    }
  }

  // load(obj: any): void {
  //   super.load(obj);
  //   if (obj) {
  //     this.armor_type_id = obj.armor_type_id ? obj.armor_type_id : "";
  //     this.base_armor_class = obj.base_armor_class ? obj.base_armor_class : 10;
  //     this.stealth_disadvantage = obj.stealth_disadvantage ? obj.stealth_disadvantage : null;
  //     this.require_special_proficiency = obj.require_special_proficiency ? obj.require_special_proficiency : false;
  //     // this.dex_bonus_max = obj.dex_bonus_max ? obj.dex_bonus_max : -1;
  //     // this.speed_loss = obj.speed_loss ? obj.speed_loss : 0;
  //     // this.comfortable = obj.comfortable ? obj.comfortable : false;
  //   }
  // }

  get armor_type_name(): string {
    if (this.armor_type) {
      return this.armor_type.name;
    } else {
      return "";
    }
  }
  
  use_stealth_disadvantage(): boolean {
    if (this.stealth_disadvantage === null) {
      if (this.armor_type) {
        return this.armor_type.stealth_disadvantage;
      } else {
        return false;
      }
    } else {
      return this.stealth_disadvantage;
    }
  }

  toDBObj(): any {
    const base_db_obj = super.toDBObj();
    return {
      ...base_db_obj,
      armor_type_id: this.armor_type_id,
      base_armor_class: this.base_armor_class,
      stealth_disadvantage: this.stealth_disadvantage,
      require_special_proficiency: this.require_special_proficiency,
      strength_requirement: this.strength_requirement,
      // dex_bonus_max: this.dex_bonus_max,
      // speed_loss: this.speed_loss,
      // comfortable: this.comfortable
    };
  }

  toLight(): any {
    const base_db_obj = super.toLight();
    return {
      ...base_db_obj,
      armor_type_id: this.armor_type_id,
      base_armor_class: this.base_armor_class,
      stealth_disadvantage: this.stealth_disadvantage,
      require_special_proficiency: this.require_special_proficiency,
      strength_requirement: this.strength_requirement,
    };
  }

  clone(drop_ids = false): Armor {
    const new_obj = new Armor();
    new_obj.copy(this, drop_ids);
    return new_obj;
  }

  copy(copyMe: Armor, drop_ids = false): void {
    super.copy(copyMe, drop_ids);
    this.item_type = copyMe.item_type;
    this.b_weight = copyMe.b_weight;
    this.cost = copyMe.cost;
    // this.magical = copyMe.magical;
    this.armor_type_id = copyMe.armor_type_id;
    this.base_armor_class = copyMe.base_armor_class;
    this.armor_type = copyMe.armor_type;
    this.stealth_disadvantage = copyMe.stealth_disadvantage;
    this.require_special_proficiency = copyMe.require_special_proficiency;
    this.strength_requirement = copyMe.strength_requirement;
    // this.dex_bonus_max = copyMe.dex_bonus_max;
    // this.speed_loss = copyMe.speed_loss;
    // this.comfortable = copyMe.comfortable;
  }
}
